// extracted by mini-css-extract-plugin
export var btnBlock = "style-module--btn-block--4c077";
export var container = "style-module--container--6ed1e";
export var desc = "style-module--desc--d8987";
export var icon = "style-module--icon--0bc67";
export var left = "style-module--left--8e2c7";
export var order = "style-module--order--e2b7c";
export var right = "style-module--right--394f2";
export var wait = "style-module--wait--7b170";